import React from 'react';
import { PayoutMethodTypes, updatePayoutMethod } from 'api/payoutMethods';
import { Modal } from 'ui-kit';
import { message } from 'antd';
import BasePayoutMethodForm from './BasePayoutMethodForm';
import { PayoutMethod } from 'api/types/payout';
import { useSignedUser } from 'api/auth';
import { YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR } from 'consts';

type Props = {
  payoutMethod?: PayoutMethod;
  visible: boolean;
  handleClose: () => void;
};

export default function EditPayoutMethodModal({ payoutMethod, visible, handleClose }: Props) {
  const { data: user } = useSignedUser();
  const onSubmit = ({ nickname, accountId, isDefault }) => {
    const payload = { owner: user.owner_id, nickname, accountId, isDefault };
    if (payoutMethod.type !== PayoutMethodTypes.PAYPAL) {
      // only allow changing account ids for paypal payout methods
      delete payload.accountId;
    }
    // TODO: this should be migrated to the new SDK and API
    return updatePayoutMethod(payoutMethod.id, payload).then((res) => {
      if (res.ok) {
        message.info('Payout method updated successfully!');
        handleClose();
      } else {
        if (
          Object.values(res?.errors?.fields)?.[0] ===
          YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR
        ) {
          message.error(YOU_DO_NOT_HAVE_PERMISSION_TO_THIS_ACTION_ERROR);
          return;
        }

        message.error(
          Object.values(res?.errors?.fields)?.[0]?.[0] || 'Error updating payout method.',
        );
      }
    });
  };
  return (
    <Modal
      className="AddPayoutMethodModal"
      visible={visible}
      footer={null}
      destroyOnClose
      onCancel={handleClose}
    >
      <BasePayoutMethodForm
        mode="edit"
        type={payoutMethod?.type}
        onSubmit={onSubmit}
        initialPayoutMethod={payoutMethod}
      />
    </Modal>
  );
}
